import type { TRuleWithTheme } from '@ackee/fela';
import { BackgroundMode } from '../PixelatedBackgroundWrapper/constants';

type Props = { backgroundMode?: BackgroundMode };

export const extendContainer: TRuleWithTheme = () => ({

    tablet: {
      paddingTop: 0,
    },
    tabletLarge: {
      paddingTop: 0,
    },

});

export const extendTitle: TRuleWithTheme<Props> = ({ theme, backgroundMode }) => ({

    maxWidth: '360px',
    marginBottom: '2rem',
    color: backgroundMode === BackgroundMode.Dark ? theme.colors.white : theme.colors.black,

    tablet: {
      marginBottom: 0,
      lineHeight: '3.2rem',
    },

});

export const extendLogoContainer: TRuleWithTheme = () => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'baseline',

    tablet: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      paddingRight: '40px',
    },
  
});

export const divider: TRuleWithTheme<Props> = ({ theme, backgroundMode }) => ({
  width: '100%',
  height: '1px',
  background: backgroundMode === BackgroundMode.Dark ? theme.colors.white : theme.colors.black,
  marginBottom: '1rem',

  tablet: {
    width: '1px',
    height: '168px',
    marginTop: '50px',
    marginBottom: 0,
  },
});

const logo: TRuleWithTheme = () => ({
    marginTop: '2rem',
});

export const white: TRuleWithTheme = () => ({
  filter: 'brightness(0) invert(1)',
});

export const multimedia: TRuleWithTheme = () => ({
  marginTop: '2rem',
  maxWidth: '151px',
});

export const gba: TRuleWithTheme = () => ({
  marginTop: '2rem',
  maxWidth: '159px',
});

export const deloitte: TRuleWithTheme = () => ({
  marginTop: '2rem',
  maxWidth: '234px',
}); 